export default function LangToggle({ lang, setLang, testidPrefix = "form" }) {
  return (
    <div className="flex items-center gap-1 eyebrow border border-ink/25 shrink-0">
      <button
        type="button"
        onClick={() => setLang("ro")}
        data-testid={`${testidPrefix}-lang-ro`}
        className={`px-4 py-2 transition-colors ${lang === "ro" ? "bg-ink text-paper" : "hover:bg-ink/5"}`}
      >
        RO
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid={`${testidPrefix}-lang-en`}
        className={`px-4 py-2 transition-colors ${lang === "en" ? "bg-ink text-paper" : "hover:bg-ink/5"}`}
      >
        EN
      </button>
    </div>
  );
}
